
export const GET_COMMERCIAL_MANAGERS_LIST_SUCCESS = 'GET_COMMERCIAL_MANAGERS_LIST_SUCCESS';
export const GET_COMMERCIAL_MANAGERS_LIST_FAIL = 'GET_COMMERCIAL_MANAGERS_LIST_FAIL';

export const GET_COMMERCIAL_MANAGERS_SUCCESS = 'GET_COMMERCIAL_MANAGERS_SUCCESS';
export const GET_COMMERCIAL_MANAGERS_FAIL = 'GET_COMMERCIAL_MANAGERS_FAIL';